import ActionCable from 'actioncable'
import { getAuth } from '@/utils'

let consumer = null

export function getCableConsumer () {
  if (consumer) return consumer

  const auth = getAuth()
  if (!auth.token) return null

  const { protocol, host } = new URL(process.env.VUE_APP_API_URL)
  const wsUrl = `${protocol.replace('http', 'ws')}//${host}`
  const params = new URLSearchParams({
    token: auth.token,
    email: auth.email || '',
  })
  consumer = ActionCable.createConsumer(
    `${wsUrl}/cable?${params.toString()}`
  )
  return consumer
}

export function disconnectCable () {
  consumer?.disconnect()
  consumer = null
}
